import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type MarketingStatItem = {
  value: string;
  label: string;
  icon?: string;
};

@Component({
  selector: 'app-marketing-stats-strip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (stats.length) {
      <section class="h1-stats" aria-label="Key statistics">
        <div class="h1-stats__card">
          @for (s of stats; track s.label) {
            <div class="h1-stat">
              @if (s.icon) {
                <div class="h1-stat__icon" aria-hidden="true">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    focusable="false"
                  >
                    @switch (iconKey(s.icon)) {
                      @case ('wallet') {
                        <rect width="20" height="14" x="2" y="5" rx="2" />
                        <path d="M2 10h20" />
                      }
                      @case ('briefcase') {
                        <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                        <rect width="20" height="14" x="2" y="6" rx="2" />
                      }
                      @case ('trending') {
                        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                        <polyline points="16 7 22 7 22 13" />
                      }
                      @case ('award') {
                        <circle cx="12" cy="8" r="6" />
                        <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
                      }
                      @default {
                        <circle cx="12" cy="8" r="6" />
                        <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
                      }
                    }
                  </svg>
                </div>
              }
              <div class="h1-stat__value">{{ s.value }}</div>
              <div class="h1-stat__label">{{ s.label }}</div>
            </div>
          }
        </div>
      </section>
    }
  `,
})
export class MarketingStatsStripComponent {
  @Input() stats: MarketingStatItem[] = [];

  iconKey(icon: string | undefined): string {
    const key = (icon ?? '').trim().toLowerCase();
    if (key === 'trending-up' || key === 'trending-up-icon') return 'trending';
    if (key === 'medal') return 'award';
    return key;
  }
}
